import {
  HttpClient,
  HttpErrorResponse,
  HttpStatusCode,
} from '@angular/common/http';
import { Injectable } from '@angular/core';
import { catchError, map, of, throwError } from 'rxjs';
import { MapNoteModel } from '../models/map-note.model';
import { MapModel, MapModelLike } from '../models/map.model';
import { ObjectUtils } from '../utils/object.utils';

@Injectable()
export class MapsService {
  constructor(private http: HttpClient) {}

  listMaps() {
    return this.http.get<MapModelLike[]>(`~MyMap/FindAllByUser`).pipe(
      map((list) => {
        list = list.map((item) => this.apiModelToLocalModel(item));
        return list;
      })
    );
  }

  createPublicMap(model: MapModelLike) {
    let body: any = this.localModelToApiModel(model);
    return this.http.post<MapModelLike>(`~MyMap/CreatePublic`, body);
  }

  createMap(model: MapModelLike) {
    let body: any = this.localModelToApiModel(model);
    return this.http.post(`~MyMap`, body);
  }

  updateMap(mapId: string, model: MapModelLike) {
    let body: any = this.localModelToApiModel(model);
    body = ObjectUtils.merge(body, {
      id: mapId,
    });
    return this.http.put(`~MyMap`, body);
  }

  deleteMap(mapId: string) {
    return this.http.delete(`~MyMap/${mapId}`);
  }

  copyMap(mapId: string) {
    return this.http.post(`~MyMap/Copy`, {
      id: mapId,
    });
  }

  shareMapWithMyEntity(mapId: string) {
    return this.http.post(`~MyMap/ShareMapWithEntityAccounts`, null, {
      params: { mapId },
    });
  }

  setAsFavorite(mapId: string, favorite: boolean) {
    return this.http.post<any>(`~MyMap/SetFavorite`, {
      id: mapId,
      favorite,
    });
  }

  getFavoriteMap() {
    return this.http.get<MapModelLike>(`~MyMap/GetFavorite`).pipe(
      map((item) => {
        return this.apiModelToLocalModel(item);
      }),
      catchError((response) => {
        if (response instanceof HttpErrorResponse) {
          if (response.status === HttpStatusCode.NotFound) {
            return of(null);
          }
        }

        return throwError(response);
      })
    );
  }

  getMapById(mapId: string) {
    return this.http.get<MapModelLike>(`~MyMap/${mapId}`).pipe(
      map((item) => {
        return this.apiModelToLocalModel(item);
      })
    );
  }

  private apiModelToLocalModel(apiModel: any): MapModel {
    if (!apiModel) {
      return null;
    }

    const model = new MapModel(apiModel);
    model.notes =
      apiModel.anotations?.map(({ anotation }) => {
        const note = new MapNoteModel(JSON.parse(anotation));
        return note;
      }) ?? [];

    return model;
  }

  private localModelToApiModel(model: MapModelLike) {
    let body: any = Object.assign({}, model);

    const notes =
      body.notes?.map((note) => {
        const anotation = JSON.stringify(note);
        return { anotation };
      }) ?? [];
    delete body.notes;

    const viewPointStr = JSON.stringify(body.viewPoint);
    delete body.viewPoint;

    body = ObjectUtils.clone(body);

    body.viewPoint = viewPointStr;
    body.anotations = notes;

    return body;
  }
}
